import React from "react";
import { useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import SideBar from "./SideBar";
import { fetchFromAPI } from "../utils/fetchFromAPI";
import Videos from "./Videos";
import { mediaLists } from "../utils/constants";

const Feed = () => {
  const [selectedCategory, setSelectedCategory] = useState("New");
  const [videos, setVideos] = useState([]);
  // console.log(selectedCategory);
  useEffect(() => {
    setVideos([]);

    // fetchFromAPI(`search?part=snippet&q=${selectedCategory}`).then((data) =>{
    //   console.log("inside set videos function");      
    //   console.log(data);
    //   console.log(data.items);      
    //   setVideos(data.items)
    // });
    console.log(mediaLists);
    
    setVideos(mediaLists)

    
  }, [selectedCategory]);
  
  return (
    <Stack sx={{ flexDirection: { sx: "column", md: "row" } }}>
      {/* Box for Sidebar */}
      <Box
        sx={{
          height: { sx: "auto", md: "92vh" },
          borderRight: "1px solid #3d3d3d",
          px: { sx: 0, md: 2 },
        }}
      >
        {/* Creating Sidebar */}
        <SideBar
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <Typography
          className="copyright"
          variant="body2"
          sx={{ mt: 1.5, color: "#fff" }}
        >
          Copyright 2025 PS Video
        </Typography>
      </Box>
      {/* Box for Videos */}
      <Box
        p={2}
        sx={{ overflowY: "auto", flex: "auto", height: "90vh" }}
        margin="auto"
      >
        <Typography
          varient="h4"
          fontWeight="bold"
          mb={2}
          sx={{ color: "white" }}
        >
          <span>
            {selectedCategory}{" "}
            <span
              style={{
                color: "#F31503",
              }}
            >
              Videos
            </span>
          </span>
        </Typography>

        <Videos videos={videos} />
      </Box>
    </Stack>
  );
};

export default Feed;
